import { useId, useState } from 'react';
import { SparklesIcon } from 'assets/icons';
import { qualificationText } from './qualificationTexts';

const MARK_ICON_COLOR = '#4B5563'; // gray-600

const TOOLTIP_ALIGN_CLASS = {
  center: 'left-1/2 -translate-x-1/2',
  end: 'right-0',
};

/**
 * Grey sparkle marking a value proposed by the AI, with a dark "Suggéré par
 * l'IA" tooltip on hover and on keyboard focus. The tooltip stays in the DOM
 * (hidden while closed) so `aria-describedby` always points to a real node.
 * `align="end"` keeps the tooltip inside the panel for marks on its right edge.
 */
const AiSuggestedMark = ({ align = 'center', className = '' }) => {
  const tooltipId = useId();
  const [isOpen, setIsOpen] = useState(false);
  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  return (
    <span
      className={`relative inline-flex shrink-0 self-center ${className}`}
      onMouseEnter={open}
      onMouseLeave={close}
    >
      <span
        role="img"
        tabIndex={0}
        aria-label={qualificationText('ai.markLabel')}
        aria-describedby={tooltipId}
        data-testid="ai-suggested-mark"
        className="inline-flex h-5 w-5 cursor-default items-center justify-center rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow-500"
        onFocus={open}
        onBlur={close}
        onKeyDown={(event) => {
          if (event.key === 'Escape') close();
        }}
      >
        <SparklesIcon wh={16} color={MARK_ICON_COLOR} />
      </span>
      <span
        role="tooltip"
        id={tooltipId}
        hidden={!isOpen}
        className={`pointer-events-none absolute top-full z-20 mt-1 whitespace-nowrap rounded-md bg-gray-800 px-2.5 py-1.5 text-xs font-medium text-white shadow-lg ${
          TOOLTIP_ALIGN_CLASS[align] ?? TOOLTIP_ALIGN_CLASS.center
        }`}
      >
        {qualificationText('ai.badge')}
      </span>
    </span>
  );
};

export default AiSuggestedMark;
